import { CharacterPortrait, DialogueItem, SceneElement } from '../../types';
import {
  CharacterPlacement,
  PLACEMENT_X,
  buildMoodsFromPortrait,
  buildVirtualCharacterElement,
  characterElementId,
  defaultMoodFor,
  getDialoguePlacement as getDialoguePlacementFromRuntime,
  placementFromX,
} from '../../systems/character-runtime';

export type { CharacterPlacement };
export { PLACEMENT_X, placementFromX, characterElementId, buildMoodsFromPortrait, defaultMoodFor };

export function findCharacterElement(
  elements: SceneElement[] | undefined,
  characterId: string,
  elementId?: string
): SceneElement | undefined {
  const els = elements ?? [];
  if (elementId) {
    const byId = els.find((e) => e.id === elementId);
    if (byId) return byId;
  }
  const canonical = characterElementId(characterId);
  return els.find(
    (e) =>
      e.type === 'character' &&
      (e.id === canonical || e.id === characterId || e.id.includes(characterId))
  );
}

/** @deprecated Virtual sprites use metadata.characters — kept for editor previews. */
export function buildCharacterElement(
  char: CharacterPortrait,
  placement: CharacterPlacement,
  existingId?: string
): SceneElement {
  return buildVirtualCharacterElement(char, placement, existingId);
}

export interface DialogueCharacterSyncResult {
  dialogue: DialogueItem;
  elements?: SceneElement[];
}

/** Link a dialogue line to a metadata character (no scene.elements mutation). */
export function syncDialogueCharacter(
  dialogue: DialogueItem,
  _elements: SceneElement[] | undefined,
  char: CharacterPortrait,
  placement: CharacterPlacement
): DialogueCharacterSyncResult {
  const resolvedMood = defaultMoodFor(char, dialogue.emotion ?? 'neutre');

  const updatedDialogue: DialogueItem = {
    ...dialogue,
    characterId: char.id,
    speaker: dialogue.speaker?.trim() ? dialogue.speaker : char.name,
    isInternal: undefined,
    placement,
    emotion: resolvedMood,
    characterMood: undefined,
  };

  return { dialogue: updatedDialogue };
}

export function getDialoguePlacement(
  dialogue: DialogueItem,
  elements: SceneElement[] | undefined
): CharacterPlacement {
  return getDialoguePlacementFromRuntime(dialogue, elements);
}
